import React, { useEffect } from "react";
import Cell from "./Cell";

export const TableRowLabels = ({ tableData }) => {
    const [firstTableRowWidths, setFirstTableRowWidths] = React.useState([]);
    const [allRowsHeights, setAllRowsHeights] = React.useState([]);
    const tableBody = document.getElementById("table-preview-renderer-body");
    // force rerender on tableData change
    useEffect(() => {
        let tempFirstTableRowWidths = [];
        let tempAllRowsHeights = [];
        const rowElem = tableBody?.childNodes[0];
        rowElem?.childNodes?.forEach((cell) => {
            tempFirstTableRowWidths.push(cell.offsetWidth);
        }) ?? [];

        tableBody?.childNodes?.forEach((row) => {
            const rowHeight = row.offsetHeight;
            tempAllRowsHeights.push(rowHeight);
        });

        setFirstTableRowWidths(tempFirstTableRowWidths);
        setAllRowsHeights(tempAllRowsHeights);
    }, [tableData]);

    return (
        <>
            <div
                style={{
                    display: "grid",
                    gridTemplateColumns: firstTableRowWidths
                        .map((width) => `${width}px`)
                        .join(" "),
                    height: "20px",
                    position: "relative",
                    marginBottom: "10px",
                }}
            >
                {firstTableRowWidths.map((width, index) => {
                    return (
                        <p style={{ textAlign: "center", fontSize: "" }}>
                            {width}px
                        </p>
                    );
                })}
                <div
                    style={{
                        position: "absolute",
                        left: tableBody?.offsetLeft - 100 ?? 0,
                        top: 30,
                        width: "100px",
                        display: "grid",
                        gridTemplateRows: allRowsHeights
                            .map((height) => `${height}px`)
                            .join(" "),
                    }}
                >
                    {allRowsHeights.map((height, index) => {
                        return (
                            <div
                                style={{
                                    textAlign: "center",
                                    fontSize: "",
                                    display: "grid",
                                    placeItems: "center",
                                }}
                            >
                                {height}px
                            </div>
                        );
                    })}
                </div>
            </div>
        </>
    );
};

const TableRowComponent = ({ rowProps, rowIndex, row }) => {
    return (
        <tr key={rowIndex} id={`table-row-${rowIndex}`}>
            {row.map((cell, cellIndex) => {
                return (
                    <Cell
                        cell={cell}
                        rowIndex={rowIndex}
                        cellIndex={cellIndex}
                        {...rowProps}
                        key={cellIndex}
                    />
                );
            })}
        </tr>
    );
};

export default TableRowComponent;
